// First things first, enable global error handling
import { NgModuleRef } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

import { GeolocationService, NativeBridgeService, TimeAndGeoipProvider } from '@fcom/core/services';
import { captureException, initSentry } from '@fcom/core/services/sentry/sentry.module';
import {
  hashParametersFromUrl,
  parseGeolocationFromUrlHash,
  parseNativeClickSourceFromUrlHash,
  UrlHashParameters,
} from '@fcom/dapi/utils';

import { ClientModule } from './app/client.module';
import { environment } from '../../environments/environment';

initSentry();

export { captureException };

export const preInit = (module: NgModuleRef<ClientModule>) => {
  const geoIpProvider: TimeAndGeoipProvider = module.injector.get(TimeAndGeoipProvider);
  const geolocationService: GeolocationService = module.injector.get(GeolocationService);
  const nativeBridgeService: NativeBridgeService = module.injector.get(NativeBridgeService);
  const sanitizer: DomSanitizer = module.injector.get(DomSanitizer);
  geoIpProvider.triggerTimeAndGeoipFetch();

  const urlParams: UrlHashParameters = hashParametersFromUrl(sanitizer);

  geolocationService.init(parseGeolocationFromUrlHash(urlParams));
  nativeBridgeService.init(parseNativeClickSourceFromUrlHash(urlParams));
};

export const init = (): Function => {
  if (!environment.storageRoot) {
    const match = /storageRoot=(\w+)/.exec(window.location.search);
    window['storageRoot'] = match?.[1] || '';
  }

  return () => {};
};
